import { format } from "date-fns";
import { toValidDate } from "../../../utils/date";
import type { PublicationModel } from "./types";

// The comparators the dirty diff (§12) and the undo step delta share: what
// "the same post" means when two snapshots of a session are held side by
// side. Dates compare to the minute (the schedule's own granularity), the
// payload structurally.

export function areDatesEqualToMinute(
  a?: Date | null,
  b?: Date | null,
): boolean {
  if (!a && !b) return true;
  if (!a || !b) return false;
  return format(a, "yyyy-MM-dd HH:mm") === format(b, "yyyy-MM-dd HH:mm");
}

export function deepEqual(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (a == null || b == null) return a === b;
  if (typeof a !== typeof b) return false;
  if (typeof a !== "object") return false;
  const aObj = a as Record<string, unknown>;
  const bObj = b as Record<string, unknown>;
  const aKeys = Object.keys(aObj);
  const bKeys = Object.keys(bObj);
  if (aKeys.length !== bKeys.length) return false;
  return aKeys.every((key) => deepEqual(aObj[key], bObj[key]));
}

export type PubSnapshot = {
  scheduledAt: Date | null;
  postInfo: unknown;
  status: string;
  exists: boolean;
};

export function snapshotPub(pub: PublicationModel | undefined): PubSnapshot {
  if (!pub) return { scheduledAt: null, postInfo: null, status: "", exists: false };
  return {
    scheduledAt: toValidDate(pub.scheduledAt) ?? null,
    postInfo: pub.postInfo,
    status: pub.status,
    exists: true,
  };
}

export function pubsEqual(a: PubSnapshot, b: PubSnapshot): boolean {
  if (a.exists !== b.exists) return false;
  if (!a.exists && !b.exists) return true;
  if (a.status !== b.status) return false;
  if (!areDatesEqualToMinute(a.scheduledAt, b.scheduledAt)) return false;
  return deepEqual(a.postInfo, b.postInfo);
}
